import { crashReporterInterface } from 'app-components/utils/core';
import { bugsnagBreadcrumb, bugsnagNotify } from 'utils/core/bugsnag';

// implement shared interfaces
crashReporterInterface.crashReporterInterfaceInit({
  reportError: (error, customDetails = {}, reportOverrides = {}) =>
    bugsnagNotify(error, (report) => {
      Object.entries(reportOverrides).forEach(([key, value]) => {
        report[key] = value;
      }); // eslint-disable-line no-param-reassign
      Object.entries(customDetails).forEach(([key, value]) => report.addMetadata(key, value));
    }),
  addBreadcrumb: (name, metadata, type) => bugsnagBreadcrumb(name, metadata, type),
});
